"use client";

import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  id: 1,
  number: "01",
  title: "Upload Your Content",
  description: "Easily upload videos in high definition through our intuitive interface",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1533057/img/upload_video_interface.png"
}, {
  id: 2,
  number: "02",
  title: "Customize Your Channel",
  description: "Brand your channel with custom layouts, colors, and descriptions",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1533057/img/customize_channel_branding.png"
}, {
  id: 3,
  number: "03",
  title: "Enable Monetization",
  description: "Activate built-in ads to start generating revenue from your audience",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1533057/img/enable_ads_monetization.png"
}, {
  id: 4,
  number: "04",
  title: "Grow Your Audience",
  description: "Engage viewers through comments, subscriptions, and analytics insights",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1533057/img/grow_audience_engagement.png"
}];
export default function HowItWorks() {
  const {
    ref: containerRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section id="how-it-works" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4">
            How It Works
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">Get started with ViddTube in four simple steps and begin sharing your content with the world</p>
        </div>

        <div ref={containerRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
          {steps.map((step, i) => <div key={step.id} data-index={i} className={`flex flex-col items-center text-center transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`} style={{
          transitionDelay: isVisible ? `${i * 100}ms` : "0ms"
        }}>
              <div className="relative w-full aspect-square max-w-[280px] mb-6 overflow-hidden rounded-lg shadow-soft">
                <img src={step.image} alt={step.title} className="w-full h-full object-cover" />
              </div>

              <Badge variant="default" className="mb-4 px-4 py-2 text-base font-bold bg-primary text-foreground-primary hover:scale-105 transition-transform duration-[var(--duration-fast)]">
                {step.number}
              </Badge>

              <h3 className="text-xl md:text-2xl font-display font-semibold text-foreground mb-3">
                {step.title}
              </h3>

              <p className="text-sm md:text-base text-muted-foreground max-w-[280px]">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}